import { AfterViewInit, ChangeDetectorRef, Component, effect, EventEmitter, Inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { DialogService } from '@app/lib/services/dialog.service';
import { filter, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ETaskScreenName, IAssignedTaskEvent } from '../models/assigned-task.model';
import { ICaseItem } from '../models/case-assignment.model';
import { ECasePartyRoleType } from '../models/constant';
import { AssignedTaskService } from '../services/assigned-task.service';
import { DocumentReceptionService } from '../services/document-reception.service';
import { CaseDataPayload, DocParty, IDRAttachment, IDRCaseDocument, IDRCaseSearchRequestBody, IDRPartyRepresentationDTO, Label } from '../models/document-reception.model';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogModule, MatDialogConfig } from '@angular/material/dialog';
import { AlphaNumSlashDirective } from '@app/shared/alpha-num-slash.directive';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconRegistry } from '@angular/material/icon'; // Import this
import { DomSanitizer } from '@angular/platform-browser'; // Import this
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CourtStaffRoleService } from '../services/court-staff-roles.service';
import { Courts, CourtsForRole, CourtStaff, CUSTOM_DATE_FORMATS, CustomTtRoleDtlsDTO, ICourtUnitType, RoleAssignment, StaffAbsence, StaffAbsencesTypes, StaffAssignment } from '../models/court-staff-roles.model';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { IResponse } from '@app/lib/models/response.model';
import { TAny } from '@app/lib/models/common.type';
import { MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-court-staff-roles',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    BreadcrumbComponent,
    MatDatepickerModule,
    ScrollingModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTooltipModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './court-staff-roles.component.html',
  styleUrl: './court-staff-roles.component.scss',
  providers: [DatePipe, MatDialogConfig, { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }]
})
export class CourtStaffRolesComponent implements OnInit, AfterViewInit {

  today: Date = new Date();
  displayedColumns: string[] = [];
  columnDefinitions: any[] = [];
  public court: FormControl = new FormControl('');
  selectedCourt: CourtsForRole[] | null = null;
  courts: Courts[] = [];
  modifyRoleAssigment: RoleAssignment[] = [];
  modifyStaffAssigment: StaffAssignment[] = [];
  modifyStaffAbsence: StaffAbsence[] = [];

  public roleAssignmentsData: WritableSignal<RoleAssignment[]> = signal([]);
  public staffAssignmentsData: WritableSignal<StaffAssignment[]> = signal([]);
  public staffAbsencesData: WritableSignal<StaffAbsence[]> = signal([]);

  public courtFilterCtrl: FormControl<string | null> = new FormControl<string | null>('');
  public courtStaffFilterCtrl: FormControl<string | null> = new FormControl<string | null>('');
  // List of courts filtered by search keyword
  public filteredCourts: ReplaySubject<Courts[]> = new ReplaySubject<Courts[]>(1);
  public filtercourtStaffParties: ReplaySubject<CourtStaff[]> = new ReplaySubject<CourtStaff[]>(1);

  protected _onDestroy = new Subject<void>();


  selectedTab = 'parties';

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
    { label: 'Court' },
    { label: 'Court Staff Roles' },
  ]);

  public partyRoleType = ECasePartyRoleType;

  public searchFormGrp: FormGroup = new FormGroup({
    court: new FormControl('', { nonNullable: true, validators: [Validators.required] })
  });

  public formGrp: FormGroup = new FormGroup({
    docTypeId: new FormControl('', [Validators.required]),
    casePhaseId: new FormControl('', [Validators.required]),
    motionDocumentStatus: new FormControl(''),
    comments: new FormControl(''),
  });

  public docFormGrp: FormGroup = new FormGroup({
    docUploadDateReceived: new FormControl(this.today, [Validators.required]),
    file: new FormControl('', [Validators.required]),
    selectedFile: new FormControl('', [Validators.required])
  });

  public caseListLoader: WritableSignal<boolean> = signal(false);
  public caseList: WritableSignal<ICaseItem[]> = signal([]);
  public label_enum = Label;
  public caseDataSource: MatTableDataSource<CourtStaff> = new MatTableDataSource();
  public savePayload: WritableSignal<CaseDataPayload[]> = signal([]);

  selectedData: CourtStaff[] = [];
  formattedDate: String | null = null;
  selectedFile: File | null = null;
  isAddMode: boolean = false;
  isEdit: boolean = false;
  loading: boolean = false;
  isAddSearchHandlerDD: boolean = false;
  userType: string = "";
  public attachmentsRefreshed: EventEmitter<void> = new EventEmitter<void>();
  isDashboard: boolean = false;
  minDate: Date = new Date();
  isStaffTypeLoading: boolean = false;

  public isCourtLoading: boolean = false;

  // Mock data for new staff add dropdowns
  availableStaffList: CourtStaff[] = [];

  staffTypesList: CourtStaff[] = [];
  selectedAbsence: any = null;
  selectedStaffAssignment: any = null;
  selectedRoleAssignment: any = null;

  // Child table lists and loaders
  rolesList: CustomTtRoleDtlsDTO[] = [];
  isRolesLoading: boolean = false;

  divisionsList: ICourtUnitType[] = [];
  isDivisionsLoading: boolean = false;

  absenceTypesList: StaffAbsencesTypes[] = [];
  isAbsenceTypesLoading: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private dialogService: DialogService,
    private matIconRegistry: MatIconRegistry, private sanitizer: DomSanitizer,
    private service: CourtStaffRoleService,
    private dialog: MatDialog,
  ) {
    this.matIconRegistry.addSvgIcon(
      'clipboard_add',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/backlog_add_icon.svg')
    );

  }
  ngOnInit() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.minDate = today;
    this.setTableHeaders();

    // Call the API to fetch courts
    this.getCourt();

    // Listen for search changes
    this.courtFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCourts();
      });

    this.courtStaffFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStaffParties();
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  setTableHeaders(): void {
    this.columnDefinitions = [
      {
        column: 'select', labels: '', show: true
      },
      { column: 'staffId', labels: 'Staff ID/User Name', show: true },
      { column: 'partyName', labels: 'Party Name', show: true },
      { column: 'staffType', labels: 'Staff Type', show: true },
      { column: 'userActiveUntil', labels: 'User Active Until', show: true },
      { column: 'activeRole', labels: 'Active Role', show: true },
      { column: 'assignedDivision', labels: 'Assigned Division', show: true },
    ];

    this.displayedColumns = this.columnDefinitions
      .filter(col => col.show)
      .map(col => col.column);
  }

  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit(): void {
    this.caseDataSource.sort = this.sort;

    this.caseDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'staffId':
          return item.prtId || '';
        case 'partyName':
          return item.prtName || '';
        case 'staffType':
          return item.stpName || '';
        case 'userActiveUntil':
          return item.userActiveUntil || '';
        case 'activeRole':
          return item.activeRole || '';
        case 'assignedDivision':
          return item.activeStaffAssignment || '';
        default:
          return item[property as keyof CourtStaff] as any;
      }
    };
  }

  getLabelValue(key: string): string | undefined {
    return this.label_enum[key as keyof typeof Label];
  }
  onCheckboxChange(element: any, isChecked: boolean): void {
    console.log('Selected Element:', element);
    this.selectedTab = 'roleAssignments';

    // Clear out any previous modify payload lists to force re-entry
    this.modifyRoleAssigment = [];
    this.modifyStaffAssigment = [];
    this.modifyStaffAbsence = [];
    this.isEdit = false;

    // Remove isEdit flag from child tables data
    this.roleAssignmentsData.update(data => data.filter(r => !r.isEdit));
    this.roleAssignmentsData().forEach(r => r.isEdit = false);

    this.staffAssignmentsData.update(data => data.filter(r => !r.isEdit));
    this.staffAssignmentsData().forEach(r => r.isEdit = false);

    this.staffAbsencesData.update(data => data.filter(r => !r.isEdit));
    this.staffAbsencesData().forEach(r => r.isEdit = false);

    if (isChecked) {
      if (element) {
        // Find existing selected elements and reset their edit mode
        if (this.selectedData && this.selectedData.length > 0) {
          this.selectedData.forEach(row => row.isEditMode = false);
        }

        this.selectedData = [element];
        this.roleAssignmentsData.set(element.roleAssignmentsData || [])
        this.staffAssignmentsData.set(element.staffAssignmentsData || [])
        this.staffAbsencesData.set(element.staffAbsencesData || [])
      } else {
        this.selectedData = [];
        this.roleAssignmentsData.set([])
        this.staffAssignmentsData.set([])
        this.staffAbsencesData.set([])
      }
    } else {
      console.log('Checkbox Unchecked. Clearing partyDetails and selectedData.');
      // Make sure the last selected element's edit mode is turned off
      if (this.selectedData && this.selectedData.length > 0) {
        this.selectedData.forEach(row => row.isEditMode = false);
      }
      this.selectedData = [];
      this.roleAssignmentsData.set([])
      this.staffAssignmentsData.set([])
      this.staffAbsencesData.set([])
    }
  }

  public getCourt() {
    this.isCourtLoading = true;
    this.service.getCourt().subscribe({
      next: (res: IResponse<Courts[]>) => {
        if (res && Array.isArray(res.success)) {
          // 1. Assign the data to the master list
          this.courts = res.success;

          // 2. Initialize the filtered list for the dropdown
          this.filteredCourts.next(this.courts.slice());

          this.filteredCourts.subscribe((courtsList) => {
            if (courtsList && courtsList.length === 1) {
              const singleCourt = courtsList[0];

              // Auto-select if not already selected
              if (this.searchFormGrp.get('court')?.value !== singleCourt) {
                this.searchFormGrp.get('court')?.patchValue(singleCourt);
                this.onCourtChange(singleCourt);
              }
            }
          });
          console.log('Courts loaded successfully:', this.courts);
        } else {
          console.log('No court data found.');
        }
        this.isCourtLoading = false;
      },
      error: (err) => {
        console.error('Error fetching court data:', err);
        this.isCourtLoading = false;
      },
    });
  }

  protected filterCourts() {
    if (!this.courts) return;

    let search = this.courtFilterCtrl.value;
    if (!search) {
      this.filteredCourts.next(this.courts.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter based on partyName
    this.filteredCourts.next(
      this.courts.filter(court => court.name.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterStaffParties() {
    if (!this.availableStaffList) return;

    let search = this.courtStaffFilterCtrl.value;
    if (!search) {
      this.filtercourtStaffParties.next(this.availableStaffList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtercourtStaffParties.next(
      this.availableStaffList.filter(staff => {
        const partyName = staff.prtName ? staff.prtName.toLowerCase() : '';
        const staffId = staff.prtId ? staff.prtId.toLowerCase() : '';
        return partyName.indexOf(search) > -1 || staffId.indexOf(search) > -1;
      })
    );
  }

  public searchHandler() {
    this.selectedData = [];
    this.roleAssignmentsData.set([]);
    this.staffAssignmentsData.set([]);
    this.staffAbsencesData.set([]);
    this.modifyRoleAssigment = [];
    this.modifyStaffAbsence = [];
    this.modifyStaffAssigment = [];
    this.caseDataSource.data = [];
    this.isAddMode = false;
    this.isEdit = false




    if (this.searchFormGrp.valid) {
      const court = this.searchFormGrp.value.court || '';
      const reqBody = { "name": court.name, "courtId": court.courtId };

      this.getData(reqBody);

      this.formGrp.disable();

    }
    else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please select Court',
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    }
  }

  public getData(reqBody: any) {
    this.loading = true;
    this.caseDataSource.data = [];
    this.isAddSearchHandlerDD = false;

    this.service.searchCourtStaffData(reqBody).subscribe({
      next: (res: IResponse<CourtStaff[]> | null) => {
        // Simulate a slight delay to clearly show the table loader
        setTimeout(() => {
          if (res && res.success && res.success.length > 0) {
            this.caseDataSource.data = res.success;
            this.isAddSearchHandlerDD = true;

          } else {
            this.dialogService.openDialog1({
              data: {
                title: "Information",
                message: 'No Privilege to access the data (or) No Data Exists',
                icon: 'info',
              }, disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
          }
          this.loading = false
        }, 800);
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
        this.isAddSearchHandlerDD = false;
        this.loading = false;
      },
    });
  }



  formatDateToISO(date: Date | string): string {
    return this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss') || '';
  }


  // THIS METHOD WAS MISSING AND IS NEEDED BY THE TEMPLATE
  getColumnStyle(column: string): any {
    const widths: { [key: string]: string } = {
      select: '4%',
      staffId: '15%',
      partyName: '26%',
      staffType: '15%',
      userActiveUntil: '10%',
      activeRole: '15%',
      assignedDivision: '15%',

    };

    return {
      width: widths[column] || 'auto',
      'white-space': 'normal',
      'word-break': 'break-word',
      padding: '2px 2px',
      'text-align': column === 'select' ? 'center' : 'left'
    };
  }
  public onCourtChange(selected: any): void {
    this.selectedCourt = selected;
  }

  getconfirmation(buttontype: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: "Do you want to Save",
      }, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (buttontype === 'Save') {
          const payload = this.generateSavePayload();
          this.saveModification(payload.data as any, payload.status as any);
        }
      } else {
        console.log('Cancelled!');
      }
    });
  }



  public generateSavePayload(): any {
    const payload: any[] = [];
    var transType = "";
    const hasMaster = this.hasMasterChanges();
    const courtId = this.searchFormGrp.value.court?.courtId || '';

    this.caseDataSource.data.forEach((staff: any) => {
      // Check for Add Mode
      if (staff.isAddMode) {
        transType = "I";
        payload.push({
          courtId: courtId?.toString(),
          prtId: staff.staffId || staff.prtId || "",
          prtName: staff.partyName || staff.prtName || "",
          stpId: staff.staffType?.stpId || staff.stpId || null,
          stpName: staff.staffType?.stpName || staff.staffType || staff.stpName || "",
          userName: staff.staffId || staff.userName || staff.prtId || "",
          intUserId: staff.intUserId || null,
          password: staff.password || "",
          userActiveUntil: this.formatDateToISO(staff.userActiveUntil),
          languageCode: staff.languageCode || 0,
          languageName: staff.languageName || "",
          status: "I",
          activeRole: staff.activeRole || "",
          activeStaffAssignment: staff.assignedDivision || staff.activeStaffAssignment || "",
          ...(this.modifyStaffAssigment?.length > 0 && { staffAssignmentsData: this.modifyStaffAssigment }),
          ...(this.modifyStaffAbsence?.length > 0 && { staffAbsencesData: this.modifyStaffAbsence }),
          ...(this.modifyRoleAssigment?.length > 0 && { roleAssignmentsData: this.modifyRoleAssigment })
        });
      }
      // Check for Edit/Modify Mode
      else if (staff.isEditMode) {
        const date1 = this.datePipe.transform(staff.userActiveUntil, 'ddMMMyyyy') || '';
        const originalDate = this.datePipe.transform(staff.originalUserActiveUntil, 'ddMMMyyyy') || '';
        const dateChanged = date1 !== originalDate;

        const staffTypeChanged = (staff.stpId || '') !== (staff.originalStpId || '');

        const hasNewChild = (this.modifyRoleAssigment?.length > 0) ||
          (this.modifyStaffAssigment?.length > 0) ||
          (this.modifyStaffAbsence?.some(x => x.status === 'I'));

        const calculatedStatus = hasNewChild ? "" : "U";
        transType = hasNewChild ? "I" : "U";

        payload.push({
          id: staff.id || staff.prtId,
          courtId: staff.courtId || courtId,
          prtId: staff.prtId || "",
          prtName: staff.prtName || staff.partyName || "",
          stpId: staff.staffType?.stpId || staff.stpId || null,
          stpName: staff.staffType?.stpName || staff.staffType || staff.stpName || "",
          userName: staff.userName || staff.prtId || "",
          intUserId: staff.intUserId || null,
          password: staff.password || "",
          userActiveUntil: this.formatDateToISO(staff.userActiveUntil),
          languageCode: staff.languageCode || 0,
          languageName: staff.languageName || "",
          status: calculatedStatus,
          activeRole: staff.activeRole || "",
          activeStaffAssignment: staff.activeStaffAssignment || staff.assignedDivision || "",
          ...(this.modifyStaffAssigment?.length > 0 && {
            staffAssignmentsData: this.modifyStaffAssigment = this.modifyStaffAssigment.map(({ isEdit, ...rest }) => ({ ...rest }))
          }),
          ...(this.modifyStaffAbsence?.length > 0 && {
            staffAbsencesData: this.modifyStaffAbsence = this.modifyStaffAbsence.map(({ isEdit, ...rest }) => ({ ...rest }))
          }),
          ...(this.modifyRoleAssigment?.length > 0 && {
            roleAssignmentsData: this.modifyRoleAssigment = this.modifyRoleAssigment.map(({ isEdit, ...rest }) => ({
              ...rest,
              courtstaffdata_id: staff.prtId
            }))
          })
        });
      }
    });

    return { "data": payload, "status": transType };
  }

  onStaffTypeChange(selectedId: number, element: any) {
    const selected = this.staffTypesList.find(x => x.stpId === selectedId);
    if (selected) {
      this.selectedData[0].stpId = selected.stpId;
      this.selectedData[0].stpName = selected.stpName
    }
    console.log(this.selectedData);
  }
  onDateSelected(event: any, element: any) {
    const selectedDate: Date = event.value;

    if (selectedDate) {
      const formattedDate = this.datePipe.transform(
        selectedDate,
        "yyyy-MM-dd'T'00:00:00"
      );

      this.selectedData[0].userActiveUntil = formattedDate;

      console.log("Formatted Date:", element.yourDateField);
    }
  }
  editdocument() {
    this.isEdit = true;
    if (this.selectedData && this.selectedData.length > 0) {
      if (this.staffTypesList.length === 0) {
        this.getStaffTypes();
      }
      this.selectedData.forEach((row: any) => {
        row.isEditMode = true;
        row.originalStpId = row.stpId;
        row.originalUserActiveUntil = row.userActiveUntil;

        // Ensure userActiveUntil is a JS Date object for matDatepicker
        if (row.userActiveUntil) {
          let expectedDate = row.userActiveUntil;

          if (typeof expectedDate === 'string') {
            // Check if it's strictly numbers (millisecond timestamp)
            if (/^\d+$/.test(expectedDate)) {
              expectedDate = Number(expectedDate);
            }
            // Check for dd/mm/yyyy or dd-mm-yyyy formats
            else if (expectedDate.includes('/') || expectedDate.includes('-')) {
              const separator = expectedDate.includes('/') ? '/' : '-';
              const parts = expectedDate.split(separator);

              // Assuming dd/MM/yyyy => parts[0]=dd, parts[1]=MM, parts[2]=yyyy
              if (parts.length === 3) {
                const day = Number(parts[0]);
                const month = Number(parts[1]) - 1; // JS Months are 0-indexed
                const year = Number(parts[2]);
                expectedDate = new Date(year, month, day);
              }
            }
          }

          row.userActiveUntil = new Date(expectedDate);
        }
      });
    }
  }

  public saveModification(reqBody: [], status: any) {
    this.service.saveModification(reqBody, status).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.success) {
            const dialogRef = this.dialogService.openDialog1({
              data: {
                title: "Success",
                message: res.message || "Updated Successfully",
                icon: 'check_small',
              }, disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
            // Auto reload data and restore state after success
            dialogRef.afterClosed().subscribe(() => {
              this.cancelEdit();
            });
          } else {
            this.dialogService.openDialog1({
              data: {
                title: "Information",
                message: res.message || res.data?.validString || "An error occurred",
                icon: 'info',
              }, disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
          }
        }
      },
      error: (err: any) => {
        this.dialogService.openDialog1({
          data: {
            title: "Error",
            message: "Failed to save data. Please try again.",
            icon: 'error',
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
        console.error('Error saving data:', err);
      }
    });
  }


  cancelEdit() {
    this.selectedData = [];
    this.roleAssignmentsData.set([]);
    this.staffAssignmentsData.set([]);
    this.staffAbsencesData.set([]);
    this.modifyRoleAssigment = [];
    this.modifyStaffAbsence = [];
    this.modifyStaffAssigment = [];
    this.caseDataSource.data = [];
    this.isAddMode = false;
    this.isEdit = false
    if (this.searchFormGrp.valid) {
      const court = this.searchFormGrp.value.court || '';
      const reqBody = { "name": court.name, "courtId": court.courtId };
      this.getData(reqBody);
    }
  }

  cancelChildEdit(selectedtabS: string) {
    if (selectedtabS === 'roleAssignments') {
      this.roleAssignmentsData.update(data => data.filter(r => !r.isEdit));
      this.roleAssignmentsData().forEach(r => r.isEdit = false);
    } else if (selectedtabS === 'staffAssignments') {
      this.staffAssignmentsData.update(data => data.filter(r => !r.isEdit));
      this.staffAssignmentsData().forEach(r => r.isEdit = false);
    } else if (selectedtabS === 'staffAbsence') {
      this.staffAbsencesData.update(data => data.filter(r => !r.isEdit));
      this.staffAbsencesData().forEach(r => r.isEdit = false);
    }
  }

  isStaffInList(staffId: string): boolean {
    return this.availableStaffList.some(s => s.prtId === staffId);
  }

  isStaffTypeInList(staffType: string): boolean {
    return this.staffTypesList.some(t => t.stpName === staffType || (t as any) === staffType);
  }

  isRoleInList(roleName: string): boolean {
    return this.rolesList.some(r => r.roleName === roleName);
  }

  isDivisionInList(division: string): boolean {
    return this.divisionsList.some(d => d.courtUnitName === division);
  }

  isAbsenceTypeInList(absType: string): boolean {
    return this.absenceTypesList.some(a => a.absenceTypeName === absType);
  }
  public getStaffParties() {
    if (this.availableStaffList && this.availableStaffList.length > 0 && !this.isAddMode) {
      this.filtercourtStaffParties.next(this.availableStaffList.slice());
      return;
    }

    this.loading = true;
    this.service.getstaffParties(this.searchFormGrp.value.court.courtId).subscribe({
      next: (res: IResponse<CourtStaff[]>) => {
        if (res && Array.isArray(res.success)) {
          // 1. Assign the data to the master list
          this.availableStaffList = res.success;

          // 2. Initialize the filtered list for the dropdown
          this.filtercourtStaffParties.next(this.availableStaffList.slice());

          console.log('Courts loaded successfully:', this.courts);
        } else {
          console.log('No court data found.');
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching court data:', err);
        this.loading = false;
      },
    });
  }

  public getStaffTypes() {
    if (this.staffTypesList && this.staffTypesList.length > 0) {
      return;
    }

    this.isStaffTypeLoading = true;
    this.service.getstaffTypes().subscribe({
      next: (res: IResponse<CourtStaff[]>) => {
        if (res && Array.isArray(res.success)) {
          // 1. Assign the data to the master list
          this.staffTypesList = res.success;
        } else {
          console.log('No court data found.');
        }
        this.isStaffTypeLoading = false;
      },
      error: (err) => {
        console.error('Error fetching court data:', err);
        this.isStaffTypeLoading = false;
      },
    });
  }

  public getRoles() {
    if (this.rolesList && this.rolesList.length > 0) {
      return;
    }
    this.isRolesLoading = true;

    // Fallback/Mock Implementation - REPLACE WITH REAL SERVICE CALL
    this.service.getRoles().subscribe({
      next: (res: any) => {
        this.rolesList = res.data;
        this.isRolesLoading = false;
      },
      error: () => { this.isRolesLoading = false; }
    })
  }

  public getDivisions() {
    if (this.divisionsList && this.divisionsList.length > 0) {
      return;
    }
    this.isDivisionsLoading = true;

    // Fallback/Mock Implementation - REPLACE WITH REAL SERVICE CALL
    this.service.getDivisions().subscribe({
      next: (res: any) => {
        if (res.data && res) {
          this.divisionsList = res.data || res;
          this.isDivisionsLoading = false;
        }
        else {
          this.isDivisionsLoading = false;
        }
      },
      error: () => { this.isDivisionsLoading = false; }
    })
  }

  public getAbsenceTypes() {
    if (this.absenceTypesList && this.absenceTypesList.length > 0) {
      return;
    }
    this.isAbsenceTypesLoading = true;

    // Fallback/Mock Implementation - REPLACE WITH REAL SERVICE CALL
    this.service.getAbsenceTypes().subscribe({
      next: (res: any) => {
        this.absenceTypesList = res.success || res;
        this.isAbsenceTypesLoading = false;
      },
      error: () => { this.isAbsenceTypesLoading = false; }
    })
  }

  openModal() {
    this.isAddMode = true;
    this.getStaffParties();
    if (this.staffTypesList.length === 0) {
      this.getStaffTypes();
    }
    const newStaff: any = {
      staffId: '',
      partyName: '',
      prtName: '',
      staffType: '',
      userActiveUntil: new Date(),
      activeRole: '',
      assignedDivision: '',
      isAddMode: true,
      roleAssignmentsData: [],
      staffAssignmentsData: [],
      staffAbsencesData: []
    };

    const currentData = this.caseDataSource.data || [];
    this.caseDataSource.data = [newStaff, ...currentData];
    this.selectedData = newStaff;

    // Automatically select the newly added row
    this.onCheckboxChange(newStaff, true);
  }

  onStaffIdChange(staffId: string, element: any): void {
    const selectedStaff = this.availableStaffList.find(s => s.prtId === staffId);
    if (selectedStaff) {
      element.partyName = selectedStaff.prtName;
      element.prtName = selectedStaff.prtName;
    } else {
      element.partyName = '';
      element.prtName = '';
    }
  }
  hasPendingChildEdits(tab: string): boolean {
    switch (tab) {
      case 'roleAssignments':
        return (this.modifyRoleAssigment?.length ?? 0) > 0;
      case 'staffAssignments':
        return (this.modifyStaffAssigment?.length ?? 0) > 0;
      case 'staffAbsence':
        return (this.modifyStaffAbsence?.length ?? 0) > 0;
      default:
        return false;
    }
  }

  isPastDate(dateString: string | null | undefined): boolean {
    if (!dateString) return false;
    const dateToCheck = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dateToCheck.setHours(0, 0, 0, 0);
    return dateToCheck < today;
  }

  hasMasterChanges(): boolean {
    if (this.isAddMode) {
      const hasRoles = this.modifyRoleAssigment && this.modifyRoleAssigment.length > 0;
      const hasStaffAssignments = this.modifyStaffAssigment && this.modifyStaffAssigment.length > 0;

      const validParent = !!this.searchFormGrp.value.court?.courtId &&
        !!this.selectedData[0]?.stpId &&
        !!this.selectedData[0]?.userActiveUntil;

      return hasRoles && hasStaffAssignments && validParent;
    }

    if (this.isEdit) {
      const selected = this.selectedData[0] as any;
      const date1 = this.datePipe.transform(selected?.userActiveUntil, 'ddMMMyyyy') || '';
      const originalDate = this.datePipe.transform(selected?.originalUserActiveUntil, 'ddMMMyyyy') || '';

      const dateChanged = date1 !== originalDate;
      const staffTypeChanged = (selected?.stpId || '') !== (selected?.originalStpId || '');
      const hasChildChanges = (this.modifyRoleAssigment?.length ?? 0) > 0 || (this.modifyStaffAbsence?.length ?? 0) > 0 || (this.modifyStaffAssigment?.length ?? 0) > 0;

      return dateChanged || staffTypeChanged || hasChildChanges;
    }

    return false;
  }


  childTableAddFunction(selectedtabS: string): void {
    const courtName = this.searchFormGrp.value.court.name || '';
    const courtID = this.searchFormGrp.value.court.courtId || '';
    const date = this.datePipe.transform(new Date(), "yyyy-MM-dd'T'00:00:00");
    if (selectedtabS === 'roleAssignments') {
      this.getRoles();

      let nextBeginDate = new Date();
      nextBeginDate.setHours(0, 0, 0, 0);

      // Find the most recent date from existing role assignments that don't have an end date
      const existingRoles = this.roleAssignmentsData();
      if (existingRoles && existingRoles.length > 0) {
        let maxDate = new Date(0);
        let foundActive = false;

        for (const role of existingRoles) {
          if (!role.roleEndDate) { // Looking for recent one without end date
            const rDate = new Date(role.roleBeginDate || '');
            if (rDate > maxDate) {
              maxDate = rDate;
              foundActive = true;
            }
          }
        }

        if (foundActive) {
          // If the most recent begin date is today or in the past, use Tomorrow.
          // If it is in the future, use the day after that future date.
          const maxDateStartOfDay = new Date(maxDate);
          maxDateStartOfDay.setHours(0, 0, 0, 0);

          if (maxDateStartOfDay >= nextBeginDate) {
            // It's today or in the future -> calculate maxDate + 1
            nextBeginDate = new Date(maxDateStartOfDay);
            nextBeginDate.setDate(nextBeginDate.getDate() + 1);
          } else {
            // It's in the past -> next begin date is today + 1 (Tomorrow).
            // However, the prompt says "if begin date today then select tomorrow", 
            // but if it's in the past, today is technically valid. 
            // Aligning with user prompt strictness: "recent one without end date that begin date today or future then select next date"
            nextBeginDate.setDate(nextBeginDate.getDate() + 1);
          }
        }
      }

      const dateStr = this.datePipe.transform(nextBeginDate, "yyyy-MM-dd'T'00:00:00");

      const newRole: any = {
        roleName: '',
        roleBeginDate: dateStr,
        roleEndDate: null,
        intRoleId: 0,
        status: 'I',
        courtId: courtID,
        roleLevelId: 0,
        isEdit: true,
        minBeginDate: nextBeginDate
      };
      this.roleAssignmentsData.update(data => [newRole, ...data]);
      this.modifyRoleAssigment[0] = newRole;
    } else if (selectedtabS === 'staffAssignments') {
      this.getDivisions();
      const newAssignment: StaffAssignment = {
        courtId: courtID,
        prtId: "",
        pctCases: null,
        beginDate: date,
        endDate: null,
        courtUnitId: '',
        courtUnitName: '',
        courtsId: null,
        courtsName: '',
        status: "I",
        isEdit: true,
        courtUnitTypeId: null,
        auditMessage: ''
      };
      this.staffAssignmentsData.update(data => [newAssignment as any, ...data]);
      this.modifyStaffAssigment[0] = newAssignment;
    } else if (selectedtabS === 'staffAbsence') {
      this.getAbsenceTypes();
      const newAbsence: StaffAbsence = {
        courtId: 4,
        prtId: '',
        absenceTypeId: '',
        absenceTypeName: '',
        absenceTypeDesc: '',
        sabTo: date,
        sabFrom: date,
        status: "I",
        activeFlag: "Y",
        isEdit: true,
      };
      this.selectedAbsence = newAbsence
      this.staffAbsencesData.update(data => [newAbsence as any, ...data]);
      this.modifyStaffAbsence[0] = newAbsence
    }
  };

  childTableModifyFunction(selectedtabS: string): void {
    if (selectedtabS === 'staffAbsence') {
      this.getAbsenceTypes();
      const newAbsence: StaffAbsence = {
        courtId: this.selectedAbsence.courtId,
        prtId: this.selectedAbsence.prtId,
        absenceTypeId: this.selectedAbsence.absenceTypeId,
        absenceTypeName: this.selectedAbsence.absenceTypeName,
        absenceTypeDesc: this.selectedAbsence.absenceTypeDesc,
        sabTo: this.datePipe.transform(this.selectedAbsence.sabTo, "yyyy-MM-dd'T'00:00:00"),
        sabFrom: this.datePipe.transform(this.selectedAbsence.sabTo, "yyyy-MM-dd'T'00:00:00"),
        status: "U",
        activeFlag: this.selectedAbsence.activeFlag,
        isModify: true,
      };
      this.modifyStaffAbsence[0] = newAbsence;
    }
  }

  onRoleChange(selectedRoleName: any, element: any) {

    // Find full role object from rolesList
    const selectedRoleObj = this.rolesList.find(
      role => role.intRoleId === selectedRoleName
    );
    if (selectedRoleObj) {
      this.modifyRoleAssigment[0].roleName = selectedRoleObj.roleName
      this.modifyRoleAssigment[0].roleLevelId = selectedRoleObj.roleLevelId
      this.modifyRoleAssigment[0].intRoleId = selectedRoleObj.intRoleId
      console.log('Role changed:', this.modifyRoleAssigment);
    }

  }
  onBeginDateChange(event: any, element: any) {
    const selectedDate: Date = event.value;

    if (selectedDate) {
      const formattedDate = this.datePipe.transform(
        selectedDate,
        "yyyy-MM-dd'T'00:00:00"
      );

      this.modifyRoleAssigment[0].roleBeginDate = formattedDate ?? '';

      console.log("Formatted Date:", this.modifyRoleAssigment);
    }
  }
  onDivisionChange(selectedDivision: any, element: any) {

    console.log('Selected Division Object:', selectedDivision);

    this.modifyStaffAssigment[0].courtUnitName = selectedDivision.courtUnitTypeName;
    this.modifyStaffAssigment[0].courtUnitId = selectedDivision.courtUnitTypeId; // example
    element.isModified = true;
  }

  onStaffAssignDateChange(selectedDate: any, element: any) {
    const selectDate: Date = selectedDate.value;

    if (selectDate) {
      const formattedDate = this.datePipe.transform(
        selectDate,
        "yyyy-MM-dd'T'00:00:00"
      );

      this.modifyStaffAssigment[0].beginDate = formattedDate ?? '';

      console.log("Formatted Date:", this.modifyStaffAssigment);
    }

  }
  onAbsenceSelect(isChecked: boolean, element: any) {

    if (isChecked) {
      this.selectedAbsence = element;
      this.modifyStaffAbsence = [];
      element.isModify = true;
    } else {
      this.selectedAbsence = null;
    }

    console.log('Selected Absence:', this.selectedAbsence);
  }
  onAbsenceTypeChange(selectedAbsence: any, element: any) {

    element.absenceTypeName = selectedAbsence.absenceTypeName;
    element.absenceTypeDesc = selectedAbsence.absenceTypeDesc;
    element.absenceTypeId = selectedAbsence.absenceTypeId;

    if (selectedAbsence) {
      this.modifyStaffAbsence[0].absenceTypeName = selectedAbsence.absenceTypeName
      this.modifyStaffAbsence[0].absenceTypeDesc = selectedAbsence.absenceTypeDesc
      this.modifyStaffAbsence[0].absenceTypeId = selectedAbsence.absenceTypeId
      console.log('Absence changed:', this.modifyStaffAbsence);
    }

    this.modifyStaffAbsence = this.modifyStaffAbsence.map(({ selectedAbsenceType, ...rest }) => ({
      ...rest,
    }));
  }
  onFromDateChange(date: Date, element: any) {
    const selectDate: Date = date;

    if (selectDate) {
      const formattedDate = this.datePipe.transform(
        selectDate,
        "yyyy-MM-dd'T'00:00:00"
      );

      this.modifyStaffAbsence[0].sabFrom = formattedDate ?? '';

      console.log("Formatted Absence:", this.modifyStaffAbsence);
    }

  }
  onToDateChange(date: Date, element: any) {

    const selectDate: Date = date;

    if (selectDate) {
      const formattedDate = this.datePipe.transform(
        selectDate,
        "yyyy-MM-dd'T'00:00:00"
      );

      this.modifyStaffAbsence[0].sabTo = formattedDate ?? '';

      console.log("Formatted Absence:", this.modifyStaffAbsence);
    }
  }

  onActiveFlagChange(value: string, element: any) {
    element.activeFlag = value;
    if (value === "N") {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "Record once inactivated cannot be activated again.",
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    }
  }
}